const LangList = {
  //common     /////////////////////////////////////////////////////
  loading_machine_info: [
    "Loading Machine Info...",
    "正在加载机器信息...",
    "Cargando información de la máquina ...",
  ],
  loading_gantt_data: [
    "Loading Gantt Data...",
    "正在载入甘特数据...",
    "Cargando datos de Gantt ...",
  ],
  loading_customer_info: [
    "Loading Customer Info...",
    "正在加载客户信息...",
    "Cargando información del cliente ...",
  ],
  loading_sensor_list: [
    "Loading Sensor List...",
    "正在加载传感器列表...",
    "Cargando lista de sensores ...",
  ],
  loading_sensor_data: [
    "Loading Sensor Data...",
    "正在加载传感器数据...",
    "Cargando datos del sensor ...",
  ],
  coming_soon: ["Coming Soon", "即将推出", "Muy pronto"],
  msg_add_success: ["Success to add.", "更新成功。", "Actualización exitosa."],
  msg_update_success: [
    "Update Success.",
    "更新成功。",
    "Actualización exitosa.",
  ],
  msg_success_request: [
    "Success to request.",
    "更新成功。",
    "Actualización exitosa.",
  ],
  msg_delete_success: ["Delete success.", "删除成功。", "Eliminar éxito."],
  msg_no_data_print: [
    "No data to print",
    "没有要打印的数据。",
    "No hay datos para imprimir.",
  ],
  msg_something_wrong: [
    "There's something wrong.",
    "这里有些不对劲。",
    "Algo está mal.",
  ],
  msg_userid_required: [
    "User ID is required.",
    "用户ID是必需的。",
    "El ID de usuario es obligatorio.",
  ],
  msg_userid_exists: [
    "User ID already exists.",
    "用户ID已存在。",
    "El ID de usuario ya existe.",
  ],
  msg_username_required: [
    "Username is required.",
    "用户名是必需的。",
    "El nombre de usuario es obligatorio.",
  ],
  msg_confirm_delete: [
    "Confirm Delete",
    "确认删除",
    "Confirmar eliminación",
  ],
  msg_delete_machine_warning: [
    "Are you sure you want to remove this machine?",
    "您确定要删除这个机器吗？",
    "¿Estás seguro de eliminar esta máquina?",
  ],
  ok: [
    "OK",
    "确定",
    "OK",
  ],
  cancel: [
    "Cancel",
    "取消",
    "Cancelar",
  ],
  msg_permission_denied: [
    "Permission denied. Admin access required.",
    "权限不足。需要管理员权限。",
    "Permiso denegado. Acceso de administrador requerido.",
  ],
  

  All: ["All", "全部", "Todas"],

  // Side Bar     /////////////////////////////////////////////////////
  sidebar_auto_scroll: ["Auto Scroll", "自动滚屏", "Desplazamiento automático"],
  sidebar_on: ["On", "打开", "Sobre"],
  sidebar_off: ["Off", "关", "Apagado"],
  sidebar_scroll_speed: [
    "Scroll Speed",
    "滚动速度",
    "Velocidad de desplazamiento",
  ],
  sidebar_menu_dashboard: ["Dashboard", "仪表板", "Salpicadero"],
  sidebar_menu_maintanence: ["Maintenance", "保养", "Mantenimiento"],

  // breadcrumb       ////////////////////////////////////////////////////
  breadcrumb_dashboard: ["Dashboard", "仪表板", "Salpicadero"],
  breadcrumb_job_entry: ["Job Entry", "工作录入", "Entrada de trabajo"],
  breadcrumb_reports: ["Reports", "报告书", "Reportes"],
  breadcrumb_plant_settings: [
    "Plant Settings",
    "工厂设置",
    "Configuración de la planta",
  ],
  breadcrumb_current_time: ["Current Time", "当前时间", "Tiempo actual"],
  breadcrumb_factory_time: ["Factory Time", "出厂时间", "Tiempo de fábrica"],

  // login page /////////////////////////////////////////////////////
  login_desc1: ["Machine Monitoring", "机器监控", "Monitoreo de la máquina"],
  login_desc2: [
    "Tool Monitoring/Adaptive Control",
    "刀具监控/自适应控制",
    "Monitoreo de herramientas / Control adaptativo",
  ],
  login_desc3: ["Process Monitoring", "过程监控", "Monitoreo de procesos"],
  login_username: ["Username", "用户名", "Nombre de usuario"],
  login_password: ["Password", "密码", "Contraseña"],

  login_login: ["Login", "登入", "Iniciar sesión"],
  login_error: [
    "Username or Password is wrong.",
    "用户名或密码错误",
    "Usuario o contraseña incorrectos.",
  ],
  login_has_keycode: [
    "Do you have a keycode?",
    "你有密码吗？",
    "¿Tiene un código clave?",
  ],
  login_register_here: ["Register here.", "在这里注册。", "Registrar aquí."],
  login_privacy: [
    "By using this website/application, you are agreeing to our EULA that can be found ",
    "通过使用此网站/应用程序，您同意可以找到我们的EULA。",
    "Al utilizar este sitio web / aplicación, acepta nuestro EULA que se puede encontrar ",
  ],
  login_here: ["here", "这里", "aquí."],

  // register page     /////////////////////////////////////////////////////
  register_desc: [
    "Register your own factory",
    "注册自己的工厂",
    "Registra tu propia fábrica",
  ],
  register_serial_key: ["Serial Key", "序列号", "Clave serial"],
  register_serial_key_placeholder: [
    "Specify your serial number.",
    "指定您的序列号。",
    "Especifique su número de serie.",
  ],
  register_factory_id: ["Factory Id", "工厂编号", "ID de fábrica"],
  register_factory_id_placeholder: [
    "Specify your own factory ID.",
    "指定您自己的工厂ID。",
    "Especifique su propia identificación de fábrica.",
  ],
  register_factory_name: ["Factory Name", "工厂名称", "Nombre de la fábrica"],
  register_factory_name_placeholder: [
    "Type the full name of your factory.",
    "指定工厂的全名。",
    "Especifique el nombre completo de su fábrica.",
  ],
  register_username: ["User Name", "用户名", "Nombre de usuario"],
  register_username_placeholder: [
    "Specify your username.",
    "指定您的用户名。",
    "Especifique su nombre de usuario.",
  ],
  register_fullname: ["Full Name", "全名", "Nombre completo"],
  register_fullname_placeholder: [
    "Specify your full name.",
    "指定您的全名。",
    "Especifique su nombre completo.",
  ],
  register_password: ["Password", "密码", "Contraseña"],
  register_password_placeholder: [
    "Specify the password.",
    "指定密码。",
    "Especifique la contraseña.",
  ],
  register_confirm_password: [
    "Confirm Password",
    "确认密码",
    "confirmar Contraseña",
  ],
  register_confirm_password_placeholder: [
    "Specify the password again.",
    "再次指定密码。",
    "Vuelva a especificar la contraseña.",
  ],
  register_timezone: ["TimeZone", "时区", "Zona horaria"],
  register_register: ["Register", "登记", "Inscribirse"],
  register_has_account: [
    "Do you have your account?",
    "你有你的帐号吗？",
    "¿Tiene su cuenta?",
  ],
  register_login_here: ["Login here", "在此登录", "Entre aquí"],
  register_specify: ["Please specify ", "请明确说明 ", "Por favor especifica "],

  register_logo: ["Logo", "徽标", "Logo"],

  register_err1: [
    "Factory Id should not contains space.",
    "工厂ID不能包含空格。",
    "La identificación de fábrica no debe contener espacio.",
  ],
  register_err2: [
    "Username should not contains space.",
    "用户名不能包含空格。",
    "El nombre de usuario no debe contener espacios.",
  ],
  register_err3: [
    "Please specify the password correctly.",
    "请正确输入密码。",
    "Especifique la contraseña correctamente.",
  ],
  register_err4: [
    "The Length of password must be greater than 6.",
    "密码长度必须大于6。",
    "La longitud de la contraseña debe ser superior a 6.",
  ],
  register_err5: [
    "The Factory has been created.",
    "工厂已创建。",
    "Se ha creado la Fábrica.",
  ],

  // Job Entry /////////////////////////////////////////////////////
  jobentry_id: ["ID", "ID", "ID"],
  jobentry_jobid: ["JobID", "工作 ID", "Trabajo ID"],
  jobentry_customerid: ["Customer", "顾客", "Cliente"],
  jobentry_aux1data: ["Aux1data", "顾客", "Cliente"],
  jobentry_aux2data: ["Aux2data", "顾客", "Cliente"],
  jobentry_aux3data: ["Aux3data", "顾客", "Cliente"],
  jobentry_partnumber: ["PartNumber", "零件号", "Parte no"],
  jobentry_programnumber: ["ProgramNumber", "程序编号", "Programa no"],
  jobentry_description: ["Description", "描述", "Descripción"],
  jobentry_partspercycle: [
    "PartsPerCycle",
    "每个周期的零件",
    "Partes por ciclo",
  ],
  jobentry_targetcycletime: [
    "TargetCycleTime",
    "目标循环时间",
    "Tiempo de ciclo objetivo",
  ],
  jobentry_qtyrequired: ["QtyRequired", "所需数量", "Cantidad requerida"],
  jobentry_qtycompleted: ["QtyCompleted", "完成数量", "Cantidad completada"],
  jobentry_orderdate: ["OrderDate", "订购日期", "Fecha de orden"],
  jobentry_duedate: ["DueDate", "到期日", "fecha de vencimiento"],
  jobentry_operation: ["Operation", "手术", "Operación"],
  jobentry_save: ["Save", "救", "Salvar"],
  jobentry_cancel: ["Cancel", "取消", "Cancelar"],
  jobentry_delete: ["Delete", "删除", "Borrar"],
  jobentry_remove: ["Remove", "Remove", "Remove"],
  jobentry_edit: ["Edit", "编辑", "Editar"],
  group: ["Group", "Group", "Group"],
  jobentry_suretocancel: [
    "Are you sure to cancel?",
    "您确定要取消吗？",
    "¿Estás seguro de cancelar?",
  ],
  jobentry_suretodelete: [
    "Are you sure to Delete?",
    "您确定要删除吗？",
    "¿Estás seguro de eliminarlo?",
  ],
  jobentry_addnew: ["Add Job", "添新", "Añadir nueva"],
  jobentry_uploadcsv: ["Upload CSV", "Upload CSV", "Upload CSV"],
  jobentry_editdialog: [
    "Entry Add Dialog",
    "条目添加对话框",
    "Diálogo de adición de entrada",
  ],

  // Report Page /////////////////////////////////////////////////////
  report_machine: ["Select Machine", "Select Machine", "Select Machine"],

  report_operator: ["Select Operator", "Select Operator", "Select Operator"],

  report_reportperiod: ["Report Period", "报告期间", "Periodo de informe"],
  report_reportconfiguration: [
    "Report Configuration",
    "报告配置",
    "Configuración de informes",
  ],
  report_emails: ["Emails", "电邮", "Emails"],
  report_generatepdf: ["Generate PDF", "产生PDF", "Generar PDF"],
  report_exportcsv: ["Export CSV", "导出为CSV", "Exportar a CSV"],
  report_generatecsv: ["Generate CSV", "产生CSV", "Generar CSV"],
  report_nodataprint: [
    "No date to print",
    "没有要打印的数据。",
    "No hay datos para imprimir.",
  ],
  report_from: ["From", "从", "Desde"],
  report_to: ["To", "到", "A"],

  // Plant Settings /////////////////////////////////////////////////////
  plant_plantsettings: [
    "Plant Settings",
    "工厂设置",
    "Configuración de la planta",
  ],
  plant_customername: ["Customer Name", "顾客姓名", "Nombre del cliente"],
  plant_customerlogo: ["Customer Logo", "客户徽标", "Logotipo del cliente"],
  plant_usersettings: ["User Settings", "用户设置", "Ajustes de usuario"],
  plant_adduser: ["Add User", "添加用户", "Agregar usuario"],
  plant_userid: ["User ID", "用户身份", "ID de usuario"],
  plant_username: ["Username", "用户名", "Nombre de usuario"],
  plant_password: ["Password", "密码", "Contraseña"],
  plant_fullusername: [
    "Full Username",
    "完整的用户名",
    "Nombre de usuario completo",
  ],
  plant_email: [
    "Email",
    "电子邮件",
    "Correo electrónico",
  ],
  plant_phone: [
    "Phone",
    "电话",
    "Teléfono",
  ],
  plant_email_placeholder: [
    "Enter email(s) separated by semicolon (;)",
    "输入电子邮件，用分号（;）分隔",
    "Ingrese correo(s) separado(s) por punto y coma (;)",
  ],
  plant_phone_placeholder: [
    "Enter phone number(s) separated by semicolon (;)",
    "输入电话号码，用分号（;）分隔",
    "Ingrese número(s) de teléfono separado(s) por punto y coma (;)",
  ],
  cnc_program_edit_permission: ["CNC Program Edit Permission", "CNC程序编辑权限", "Permiso de edición de programa CNC"],
  plant_barcode: ["Barcode", "Barcode", "Barcode"],
  plant_securitylevel: ["Security Level", "安全级别", "Nivel de seguridad"],
  plant_administrator: ["Administrator", "行政人员", "Administrador"],
  plant_client: ["Client", "客户", "Cliente"],
  plant_operator: ["Operator", "操作员", "Operador"],
  plant_avatar: ["Avatar", "头像", "Avatar"],
  plant_groupsetting: ["Group Settings", "群组设定", "Configuración de grupo"],
  plant_laborsetting: ["Labor Settings", "Labor Settings", "Labor Settings"],
  plant_firmwaresetting: [
    "Firmware Settings",
    "Firmware Settings",
    "Firmware Settings",
  ],
  plant_machinesetting: [
    "Machine Settings",
    "机器设定",
    "Configuración de la máquina",
  ],
  plant_addmachine: ["Add Machine", "加机", "Agregar máquina"],
  plant_addgroup: ["Add Group", "新增群组", "Añadir grupo"],
  plant_machineadddialog: [
    "Machine Add Dialog",
    "机器添加对话框",
    "Cuadro de diálogo Agregar máquina",
  ],
  plant_machineeditdialog: [
    "Machine Edit Dialog",
    "机器编辑对话框",
    "Diálogo de edición de máquina",
  ],
  plant_groupadddialog: [
    "Group Add Dialog",
    "组添加对话框",
    "Cuadro de diálogo Agregar grupo",
  ],
  plant_groupeditdialog: [
    "Group Edit Dialog",
    "组编辑对话框",
    "Diálogo de edición de grupo",
  ],
  plant_groupdialogerror: [
    "Please add group name",
    "请添加组名",
    "Por favor agregue el nombre del grupo",
  ],
  plant_machineid: ["Machine ID", "机器编号", "Identificador de máquina"],
  plant_picture: ["Picture", "图片", "Fotografía"],
  plant_createdat: ["Created at", "创建于", "Creado en"],
  plant_timesetting: ["Time Settings", "时间设定", "Configuracion de hora"],
  plant_timezone: ["Time Zone", "时区", "Zona horaria"],
  plant_update: ["Update", "更新", "Actualizar"],
  plant_reportsetting: [
    "Report Settings",
    "报告设定",
    "Configuración de informes",
  ],
  plant_reportday: ["Report Days", "报告天数", "Días de informe"],
  plant_reportemail: [
    "Report Emails",
    "报告电子邮件",
    "Informar correos electrónicos",
  ],
  plant_reportadd: ["Add", "添加", "Agregar"],
  plant_customersetting: [
    "Customer Settings",
    "客户设定",
    "Configuración del cliente",
  ],
  shift_settings: ["Shift Settings", "班次设定", "Configuración de turno"],
  shift: ["Shift", "班次", "Turno"],
  plant_tv_token_settings: [
    "TV Display Token Settings",
    "电视显示令牌设置",
    "Configuración de token de visualización de TV",
  ],
  tv_token_name: ["Token Name", "令牌名称", "Nombre del token"],
  tv_token_dashboard_type: [
    "Dashboard Type",
    "仪表板类型",
    "Tipo de panel",
  ],
  tv_token_dashboard_id: [
    "Dashboard ID",
    "仪表板ID",
    "ID del panel",
  ],
  tv_token_machine_id: [
    "Machine ID",
    "机器ID",
    "ID de máquina",
  ],
  tv_token_machine_group: [
    "Machine Group",
    "机器组",
    "Grupo de máquinas",
  ],
  tv_token_machine_group_all: [
    "All",
    "全部",
    "Todos",
  ],
  tv_token_url: ["Token URL", "令牌URL", "URL del token"],
  tv_token_created_at: [
    "Created At",
    "创建时间",
    "Creado en",
  ],
  tv_token_expires_at: [
    "Expires At",
    "过期时间",
    "Expira en",
  ],
  tv_token_last_used: [
    "Last Used",
    "最后使用",
    "Último uso",
  ],
  tv_token_copy_url: ["Copy URL", "复制URL", "Copiar URL"],
  tv_token_add_new: [
    "Add New Token",
    "添加新令牌",
    "Agregar nuevo token",
  ],
  tv_token_edit: ["Edit Token", "编辑令牌", "Editar token"],
  tv_token_delete: ["Delete Token", "删除令牌", "Eliminar token"],
  tv_token_dashboard_cnc: ["CNC Pages", "CNC页面", "Páginas CNC"],
  tv_token_dashboard_custom: [
    "Custom Dashboard",
    "自定义仪表板",
    "Panel personalizado",
  ],
  tv_token_dashboard_utilization: [
    "Utilization Dashboard",
    "利用率仪表板",
    "Panel de utilización",
  ],
  tv_token_dashboard_machine_detail: [
    "Machine Detail",
    "机器详情",
    "Detalle de máquina",
  ],
  tv_token_dashboard_machine_schedule: [
    "Machine Schedule",
    "机器计划",
    "Programa de máquina",
  ],
  tv_token_dashboard_tms: ["TMS", "TMS", "TMS"],
  tv_token_dashboard_tms_alarm: [
    "TMS Alarm",
    "TMS警报",
    "Alarma TMS",
  ],
  tv_token_dashboard_sensor: [
    "Sensor (IIoT)",
    "传感器(IIoT)",
    "Sensor (IIoT)",
  ],
  tv_token_dashboard_maintenance: [
    "Maintenance",
    "维护",
    "Mantenimiento",
  ],
  tv_token_dashboard_report: ["Report", "报告", "Informe"],

  // Notification Center
  notification_center_title: [
    "Notification Center",
    "通知中心",
    "Centro de Notificaciones",
  ],
  notification_rule_add_new: [
    "Add Notification Rule",
    "添加通知规则",
    "Agregar Regla de Notificación",
  ],
  notification_rule_edit: [
    "Edit Notification Rule",
    "编辑通知规则",
    "Editar Regla de Notificación",
  ],
  notification_rule_name: [
    "Rule Name",
    "规则名称",
    "Nombre de la Regla",
  ],
  notification_trigger_type: [
    "Trigger Type",
    "触发类型",
    "Tipo de Disparador",
  ],
  notification_trigger_downtime_setpoint: [
    "Machine Downtime > Setpoint",
    "机器停机时间 > 设定点",
    "Tiempo de Inactividad de Máquina > Punto de Ajuste",
  ],
  notification_trigger_downtime_reason: [
    "Downtime Reason Selection",
    "停机原因选择",
    "Selección de Razón de Inactividad",
  ],
  notification_trigger_maintenance_task: [
    "Maintenance Task",
    "维护任务",
    "Tarea de Mantenimiento",
  ],
  notification_trigger_iot_sensor: [
    "IoT Sensor",
    "物联网传感器",
    "Sensor IoT",
  ],
  notification_methods: [
    "Notification Methods",
    "通知方式",
    "Métodos de Notificación",
  ],
  notification_method_email: [
    "Email",
    "电子邮件",
    "Correo Electrónico",
  ],
  notification_method_sms: [
    "SMS",
    "短信",
    "SMS",
  ],
  notification_method_app: [
    "App",
    "应用程序",
    "Aplicación",
  ],
  notification_recipients_email: [
    "Email Recipients (semicolon-separated)",
    "电子邮件收件人（分号分隔）",
    "Destinatarios de Correo (separados por punto y coma)",
  ],
  notification_recipients_phone: [
    "Phone Recipients (semicolon-separated)",
    "电话收件人（分号分隔）",
    "Destinatarios de Teléfono (separados por punto y coma)",
  ],
  notification_phone_recipients_required: [
    "At least one phone number is required for SMS notifications",
    "SMS通知至少需要一个电话号码",
    "Se requiere al menos un número de teléfono para las notificaciones SMS",
  ],
  notification_timing: [
    "Timing",
    "时间",
    "Tiempo",
  ],
  notification_timing_immediate: [
    "Immediate",
    "立即",
    "Inmediato",
  ],
  notification_timing_delayed: [
    "Delayed",
    "延迟",
    "Retrasado",
  ],
  notification_delay_minutes: [
    "Delay (minutes)",
    "延迟（分钟）",
    "Retraso (minutos)",
  ],
  notification_repeat: [
    "Repeat",
    "重复",
    "Repetir",
  ],
  notification_repeat_one_time: [
    "One Time",
    "一次",
    "Una Vez",
  ],
  notification_repeat_repeat: [
    "Repeat",
    "重复",
    "Repetir",
  ],
  notification_repeat_interval: [
    "Repeat Interval (minutes)",
    "重复间隔（分钟）",
    "Intervalo de Repetición (minutos)",
  ],
  notification_active: ["Active", "激活", "Activo"],
  plant_yes:["Yes","是","Sí"],
  plant_no:["No","否","No"],
  notification_minutes: ["minutes", "分钟", "minutos"],
  notification_machines: ["Machines", "机器", "Máquinas"],
  notification_select_machines: ["Select Machines", "选择机器", "Seleccionar Máquinas"],
  notification_downtime_minutes: [
    "Downtime Threshold (minutes)",
    "停机阈值（分钟）",
    "Umbral de Inactividad (minutos)",
  ],
  notification_downtime_reasons: [
    "Downtime Reasons",
    "停机原因",
    "Razones de Inactividad",
  ],
  notification_select_downtime_reasons: [
    "Select Downtime Reasons",
    "选择停机原因",
    "Seleccionar Razones de Inactividad",
  ],
  notification_loading_downtime_reasons: [
    "Loading downtime reasons...",
    "正在加载停机原因...",
    "Cargando razones de inactividad...",
  ],
  notification_rule_name_required: [
    "Rule name is required",
    "规则名称是必需的",
    "El nombre de la regla es obligatorio",
  ],
  notification_machines_required: [
    "At least one machine must be selected",
    "必须至少选择一台机器",
    "Debe seleccionar al menos una máquina",
  ],
  notification_downtime_minutes_required: [
    "Downtime threshold is required",
    "停机阈值是必需的",
    "El umbral de inactividad es obligatorio",
  ],
  notification_downtime_reasons_required: [
    "At least one downtime reason must be selected",
    "必须至少选择一个停机原因",
    "Debe seleccionar al menos una razón de inactividad",
  ],
  notification_methods_required: [
    "At least one notification method must be selected",
    "必须至少选择一种通知方式",
    "Debe seleccionar al menos un método de notificación",
  ],
  notification_email_recipients_required: [
    "Email recipients are required when email method is selected",
    "选择电子邮件方式时必须提供收件人",
    "Los destinatarios de correo son obligatorios cuando se selecciona el método de correo",
  ],
  notification_invalid_email_format: [
    "Invalid email format",
    "无效的电子邮件格式",
    "Formato de correo electrónico inválido",
  ],
  notification_invalid_phone_format: [
    "Invalid phone number format",
    "无效的电话号码格式",
    "Formato de número de teléfono inválido",
  ],
  tv_token_dashboard_job_entry: [
    "Job Entry",
    "工作录入",
    "Entrada de trabajo",
  ],
  tv_token_expiration_optional: [
    "Expiration (Optional)",
    "过期时间（可选）",
    "Expiración (Opcional)",
  ],
  tv_token_url_copied: [
    "Token URL copied to clipboard!",
    "令牌URL已复制到剪贴板！",
    "¡URL del token copiada al portapapeles!",
  ],

  // Maintanence Page /////////////////////////////////////////////////////
  maintenance_addnew: ["Add a row", "添加一行", "Agregar una fila"],
  maintenance_machine: ["Machine", "机器", "Máquina"],
  maintenance_taskname: ["Task Name", "任务名称", "Nombre de la tarea"],
  maintenance_taskcategory: ["Task Category", "任务类别", "Categoría de tarea"],
  maintenance_taskpicture: ["Task Picture", "任务图片", "Imagen de la tarea"],
  maintenance_taskinstruction: [
    "Task Instruction",
    "任务说明",
    "Instrucción de tareas",
  ],
  maintenance_frequency: [
    "Frequency (Hrs)",
    "频率（小时）",
    "Frecuencia (horas)",
  ],
  maintenance_cycle: [
    "Cycle Start InterLock",
    "循环启动互锁",
    "Interbloqueo de inicio de ciclo",
  ],
  maintenance_timetonext: [
    "Time to Next",
    "下一个时间",
    "Tiempo hasta el siguiente",
  ],

  // CNC Page /////////////////////////////////////////////////////
  cnc_click_to_check_other_variable: [
    "Click to check other variables",
    "点击查看其他变量.",
    "Haga clic para verificar otras variables",
  ],
  cnc_guest: ["Unattended", "来宾", "Invitado"],
  cnc_offline: ["Offline", "离线", "Desconectado"],
  cnc_today: ["Today", "今天", "Hoy dia"],
  cnc_lastupdate: [
    "Last Update Time",
    "最后更新时间",
    "Hora de la última actualización",
  ],
  cnc_interface: ["Interface", "界面", "Interfaz"],
  cnc_version: ["Version", "版本", "Versión"],
  cnc_downtime: [
    "Downtime Settings",
    "停机时间设置",
    "Configuración de tiempo de inactividad",
  ],
  machine_input_signals: [
    "Machine Input Signals",
    "Machine Input Signals",
    "Machine Input Signals",
  ],
  machine_status_settings: [
    "Machine Status Settings",
    "Machine Status Settings",
    "Machine Status Settings",
  ],
  cnc_cslock: ["CSLock Settings", "CSLock设置", "Configuración de CSLock"],
  cnc_timesetting: ["Time Settings", "时间设定", "Ajustes de hora"],
  cnc_cyclealert: [
    "Cycle Stop Alert",
    "循环停止警报",
    "Alerta de parada de ciclo",
  ],
  cnc_partcounter: [
    "Automatic Part Counter",
    "自动零件计数器",
    "Contador automático de piezas",
  ],
  cnc_ganttsetting: [
    "Gantt Chart Settings",
    "甘特图设置",
    "Configuración del diagrama de Gantt",
  ],
  cnc_workflowsetting: [
    "Workflow Settings",
    "工作流设置",
    "Configuración de flujo de trabajo",
  ],
  cnc_useworkflow: [
    "Use Workflow",
    "使用工作流",
    "Usar flujo de trabajo",
  ],

  cnc_downtimereason: [
    "Downtime Reason",
    "停机原因",
    "Razón del tiempo de inactividad",
  ],
  cnc_usecycle: [
    "Use Cycle Start Interlock",
    "使用循环启动互锁",
    "Usar bloqueo de inicio de ciclo",
  ],
  cnc_reversecslock: [
    "Reverse CSlock Logic",
    "反向CSlock逻辑",
    "Lógica de bloqueo CS inversa",
  ],
  cnc_guestlock: ["Guest Lock", "访客锁", "Bloqueo de invitado"],
  cnc_enablealert: [
    "Enable Alert Sound",
    "启用警报声音",
    "Habilitar sonido de alerta",
  ],
  cnc_stoptimelimit: [
    "Stop Time Limit",
    "停止时间限制",
    "Límite de tiempo de parada",
  ],
  cnc_plannedproducttime: [
    "Planned Production Time",
    "计划生产时间",
    "Tiempo de producción planificado",
  ],
  cnc_sendalert: ["Send Alert", "发送警报", "Enviar alerta"],
  cnc_alertemail: [
    "Alert Email",
    "警报电子邮件",
    "Correo electrónico de alerta",
  ],
  cnc_alerttime: ["Alert Time", "Alert Time", "Alert Time"],
  cnc_automaticcount: ["Automatic Count", "自动计数", "Conteo automático"],
  cnc_minelapsed: [
    "Min Elapsed Cycle Time(10s)",
    "最小经过时间（10s）",
    "Tiempo de ciclo transcurrido mínimo (10 s)",
  ],
  cnc_partcycle: ["Parts per cycle", "每个周期的零件", "Partes por ciclo"],
  cnc_showgantt1: [
    "Show gantt data from 00:00 to 23:00",
    "从00:00到23:00显示甘特数据",
    "Mostrar datos de Gantt de 00:00 a 23:00",
  ],
  cnc_showgantt2: [
    "Show gantt data from 00:00 to current time",
    "显示从00:00到当前时间的甘特图数据",
    "Mostrar datos de Gantt desde las 00:00 hasta la hora actual",
  ],
  cnc_showdailygoalchart: [
    "Show Daily Goal Chart",
    "Show Daily Goal Chart",
    "Show Daily Goal Chart",
  ],
  cnc_keyindicator: [
    "Key Performance Indicators",
    "关键绩效指标",
    "Indicadores clave de rendimiento",
  ],
  cnc_oee: ["OEE", "OEE", "OEE"],
  cnc_utilization: ["Utilization", "使用率", "Utilización"],
  cnc_availability: ["Availability", "Availability", "Availability"],
  cnc_quality: ["Quality", "质量", "Calidad"],
  cnc_performance: ["Performance", "表现", "Rendimiento"],
  cnc_mainprogram: ["Main Program", "主程序", "Programa principal"],
  cnc_currentprogram: ["Current Program", "当前程序", "Programa actual"],
  cnc_goodparts: ["Good Parts", "好零件", "Buenas partes"],
  cnc_badparts: ["Bad  Parts", "不良零件", "Piezas malas"],
  cnc_loadingchart: ["Loading Chart", "加载图表", "Gráfico de carga"],

  cnc_timeline: ["Timeline", "时间线", "Cronología"],
  cnc_seedetail: [
    "See Detailed Gantt Chart",
    "查看详细的甘特图",
    "Ver diagrama de Gantt detallado",
  ],
  cnc_detailchart: [
    "Detailed Gantt Chart",
    "详细的甘特图",
    "Diagrama de Gantt detallado",
  ],
  cnc_status: ["Status", "状态", "Estado"],
  cnc_starttime: ["Start time", "开始时间", "Hora de inicio"],
  cnc_duration: ["Duration", "期间", "Duración"],
  cnc_history: ["History", "历史", "Historia"],
  cnc_nodata: ["No data", "没有数据", "Sin datos"],

  cnc_jobid: ["Job ID", "工作 ID", "Trabajo ID"],
  cnc_time: ["Time", "时间", "Hora"],
  cnc_comment: ["Comment", "评论", "Comentario"],

  // IIOT Page /////////////////////////////////////////////////////

  iiot_location: ["Location", "地点", "Localización"],
  iiot_type: ["Type", "类型", "Escribe"],
  iiot_value: ["Value", "值", "Valor"],
  iiot_updatetime: ["Update Time", "更新时间", "Tiempo de actualizacion"],

  iiot_iderror: [
    "Sensor ID is invalid.",
    "传感器ID不能为空。",
    "El ID del sensor no puede estar vacío.",
  ],
  iiot_namerror: [
    "Sensor Name can not be empty.",
    "传感器名称不能为空。",
    "El nombre del sensor no puede estar vacío.",
  ],
  iiot_addsensormodal: [
    "Add Sensor Modal",
    "添加传感器模态",
    "Agregar sensor modal",
  ],
  iiot_sensorid: ["Sensor ID", "传感器ID", "ID del sensor"],
  iiot_sensorname: ["Sensor Name", "传感器名称", "Nombre del sensor"],
  iiot_sensortype: ["Device Type", "设备类型", "Tipo de dispositivo"],
  iiot_communicationtype: ["Communication Type", "通讯类型", "Tipo de comunicación"],
  iiot_unit: ["Unit", "单元", "Unidad"],
  iiot_valuedescription: [
    "Value description",
    "值说明",
    "Descripción del valor",
  ],

  iiot_connectiongood: ["Connection Good", "连接良好", "Buena conexión"],
  iiot_connectionlost: ["Connection Lost", "连线中断", "Conexión perdida"],
  iiot_name: ["Name", "姓名", "NOMBRE"],
  iiot_sn: ["SN", "SN", "SN"],
  iiot_location_c: ["Location", "地点", "LOCALIZACIÓN"],
  iiot_connectionstatus: [
    "Connection Status",
    "连接状态",
    "Estado de conexión",
  ],
  iiot_exporttocsv: ["Export to CSV", "导出为CSV", "Exportar a CSV"],
  iiot_trendchart: ["Trend Chart", "趋势图", "Gráfico de tendencia"],

  iiot_alertsetting: ["Alert Setting", "警报设定", "Configuración de alerta"],
  iiot_minlimit: ["Min Limit", "最低限度", "Límite mínimo"],
  iiot_maxlimit: ["Max Limit", "最高限额", "Límite máximo"],
  iiot_alertto: ["Alert To", "警报到", "Alerta a"],
  iiot_updatesetting: [
    "Update Settings",
    "更新设定",
    "Ajustes de actualización",
  ],
  iiot_updatesensormodal: ["Update Sensor Modal", "", ""],
  iiot_frequency: ["Frequency", "", ""],
  iiot_alertemails: ["Alert Emails (split emails by comma)", "", ""],
  iiot_valuedescription_optional: ["Value Descriptions (optional)", "", ""],
  about_cycle_stop_alert: ["About Cycle Stop Alert", "", ""],
  cycle_alert_subtitle: [
    "Please enter your email and mobile number. If using mobile number, use following format according to your carrier.",
    "",
    "",
  ],
  metro_pcs: ["Metro PCS:", "", ""],
  metro_pcs_format: [
    "##########@mymetropcs.com",
    "##########@mymetropcs.com",
    "##########@mymetropcs.com",
  ],
  t_mobile: ["T-Mobile:", "T-Mobile:", "T-Mobile:"],
  t_mobile_format: [
    "##########@tmomail.net",
    "##########@tmomail.net",
    "##########@tmomail.net",
  ],
  verizon_wireless: [
    "Verizon Wireless:",
    "Verizon Wireless:",
    "Verizon Wireless:",
  ],
  verizon_wireless_format: [
    "##########@vtext.com",
    "##########@vtext.com",
    "##########@vtext.com",
  ],
  at_t: ["AT&T:", "AT&T:", "AT&T:"],
  at_t_format: [
    "##########@txt.att.net",
    "##########@txt.att.net",
    "##########@txt.att.net",
  ],
  sprint_pcs: ["Sprint PCS:", "Sprint PCS:", "Sprint PCS:"],
  sprint_pcs_format: [
    "##########@messaging.sprintpcs.com",
    "##########@messaging.sprintpcs.com",
    "##########@messaging.sprintpcs.com",
  ],
  nextel: ["Nextel:", "Nextel:", "Nextel:"],
  nextel_format: [
    "##########@messaging.nextel.com",
    "##########@messaging.nextel.com",
    "##########@messaging.nextel.com",
  ],
  cricket: ["Cricket:", "Cricket:", "Cricket:"],
  cricket_format: [
    "##########@sms.mycricket.com",
    "##########@sms.mycricket.com",
    "##########@sms.mycricket.com",
  ],
  us_Cellular: ["US Cellular:", "US Cellular:", "US Cellular:"],
  us_Cellular_format: [
    "##########@email.uscc.net",
    "##########@email.uscc.net",
    "##########@email.uscc.net",
  ],
  cingular1: ["Cingular (GSM):", "Cingular (GSM):", "Cingular (GSM):"],
  cingular1_format: [
    "##########@cingularme.com",
    "##########@cingularme.com",
    "##########@cingularme.com",
  ],
  cingular2: ["Cingular (TDMA):", "Cingular (TDMA):", "Cingular (TDMA):"],
  cingular2_format: [
    "##########@mmode.com",
    "##########@mmode.com",
    "##########@mmode.com",
  ],

  feature_Request_Form: [
    "Feature Request Form",
    "Feature Request Form",
    "Feature Request Form",
  ],
  feature_Request_desc: [
    "Please enter your feature request information.",
    "Please enter your feature request information.",
    "Please enter your feature request information.",
  ],
  feature_Request_Info: [
    "Feature Request Information",
    "Feature Request Information",
    "Feature Request Information",
  ],
  change_to: ["Change to", "", ""],
  select_status: ["Select status", "", ""],
  files: ["Files", "Files", "Files"],
  new_files: ["Add New Files", "添加新文件", "Agregar nuevos archivos"],
  job_entry_files: ["Job Entry Files", "Job Entry Files", "Job Entry Files"],
  maintenance_entry_files: [
    "Maintenance Entry Files",
    "Maintenance Entry Files",
    "Maintenance Entry Files",
  ],
  upload: ["Upload", "Upload", "Upload"],
  missing_param: [
    "Missing parameters",
    "Missing parameters",
    "Missing parameters",
  ],
  machine_name: ["Machine Name", "Machine Name", "Machine Name"],
  serial_number: ["Serial Number", "Serial Number", "Serial Number"],
  cycle_setting: ["Cycle Setting", "Cycle Setting", "Cycle Setting"],
  cycle_signal: ["In Cycle Signal", "In Cycle Signal", "In Cycle Signal"],
  cycle_interlock_interface: [
    "Cycle Start Interlock Interface",
    "Cycle Start Interlock Interface",
    "Cycle Start Interlock Interface",
  ],
  cycle_interlocked: [
    "Cycle Start Interlocked",
    "Cycle Start Interlocked",
    "Cycle Start Interlocked",
  ],
  on_off: ["On/Off", "On/Off", "On/Off"],
  pictures: ["Pictures", "Pictures", "Pictures"],
  files: ["Files", "文件", "Archivos"],
  add_new_file: ["Add New File", "添加新文件", "Agregar nuevo archivo"],
  upload_file: ["Upload File", "上传文件", "Subir archivo"],
  normally_closed_open: [
    "Normally Closed/Open",
    "Normally Closed/Open",
    "Normally Closed/Open",
  ],
  add_new_picture: ["Add New Picture", "添加新图片", "Agregar nueva imagen"],
  upload_picture: ["Upload Picture", "上传图片", "Subir imagen"],
  uploading: ["Uploading", "上传中", "Subiendo"],
  upload: ["Upload", "上传", "Subir"],
};

const Todo = (langIndex, word) => {
  if (langIndex === undefined) {
    langIndex = 0;
  }
  return LangList[word][langIndex % 3];
};

export default Todo;
